/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const calendarTheme = {
  defaultCardColor: '#ea580c',
  halfHourDurationMinutes: 30,
  compactDurationMinutes: 60,
  minEventPxHeight: 28,
  startHour: 0,
  endHour: 23,
  timeColumnWidth: 72,
  dayColumnMinWidth: 120,
  hourRowHeight: 60,
  colors: {
    gridBorder: '#e5e7eb',
    gridRow: '#f1f5f9',
    background: '#ffffff',
    eventBackground: '#fff7ed',
    mutedText: '#71717a',
    headingText: '#111827',
    subheadingText: '#374151',
    todayButtonBorder: '#d6d3d1',
    todayButtonHover: '#fafaf9',
    iconBadgeBackground: '#ebe7df',
    iconBadgeStroke: '#8c857b',
    previewBackground: 'rgba(120, 113, 108, 0.18)',
    previewIconBackground: 'rgba(6, 6, 6, 0.18)',
  },
  shadows: {
    event: '0 8px 18px rgba(15, 23, 42, 0.06)',
    todayButton: '0 1px 2px rgba(15, 23, 42, 0.06)',
  },
}
